import React from "react";
import loadable from "@loadable/component";
import Loading from "../Loading.js";

const LoadableComponent = loadable(() => import("./Home"), {
  fallback: <Loading />
});

const LoadableRegister = () => (
  <LoadableComponent />
)

export default LoadableRegister;
